var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppReportsLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 100,
    viewBox: "0 0 120 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110 0C115.523 0 120 4.4773 120 10.0003C120 15.5234 115.523 20.0006 110 20.0006H10C4.47716 20.0006 6.35783e-06 15.5234 6.35783e-06 10.0003C6.35783e-06 4.4773 4.47716 0 10 0H110Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110 39.998C115.523 39.998 120 44.4753 120 49.9984C120 55.5214 115.523 59.9987 110 59.9987H10C4.47716 59.9987 6.35783e-06 55.5214 6.35783e-06 49.9984C6.35783e-06 44.4753 4.47716 39.998 10 39.998H110Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60 79.9993C65.5229 79.9993 70 84.4766 70 89.9997C70 95.5227 65.5229 100 60 100H10C4.47715 100 0 95.5227 0 89.9997C0 84.4766 4.47715 79.9993 10 79.9993H60Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppReportsLogo);
export default __webpack_public_path__ + "static/media/app-reports-logo.573bcbd263232a413ea97840213fa23b.svg";
export { ForwardRef as ReactComponent };